import { cn } from "@/lib/utils";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

/** Table cell + header primitives shared across employee tabs. */
export function Th({ children, className = "" }) {
  return (
    <th
      className={cn(
        "h-10 whitespace-nowrap px-4 text-left align-middle text-[11px] font-medium uppercase tracking-[0.12em]",
        className
      )}
    >
      {children}
    </th>
  );
}

export function Td({ children, className = "", ...rest }) {
  return (
    <td
      className={cn("h-14 whitespace-nowrap px-4 align-middle", className)}
      {...rest}
    >
      {children}
    </td>
  );
}

/** Fetch a private file and open it in a new tab (blob URL). */
export function openProtectedFile(url, contentType, fallback = "fájl") {
  return api
    .get(url, { responseType: "blob" })
    .then((res) => {
      const ctype =
        contentType ||
        res.headers["content-type"] ||
        "application/octet-stream";
      const blob = new Blob([res.data], { type: ctype });
      const objUrl = URL.createObjectURL(blob);
      const w = window.open(objUrl, "_blank", "noopener");
      setTimeout(() => URL.revokeObjectURL(objUrl), 60_000);
      if (!w) toast.error("A böngésző blokkolta az új lap megnyitását.");
    })
    .catch((e) => {
      toast.error(
        formatApiError(e?.response?.data?.detail) ||
          `Nem sikerült megnyitni a(z) ${fallback}-t.`
      );
    });
}

/** Convenience wrappers for the two file endpoints used in EmployeeDetail. */
export const openSalaryPayslip = (salary) =>
  salary?._id &&
  openProtectedFile(
    `/salaries/${salary._id}/payslip`,
    salary.payslip_content_type,
    "bérjegyzék"
  );

export const openDeductionFile = (deduction) =>
  deduction?._id &&
  openProtectedFile(
    `/deductions/${deduction._id}/file`,
    deduction.content_type,
    "dokumentum"
  );
